export interface BreadcrumbItemType {
  label: string;
  to?: string;
}

export interface RouteMeta {
  title: string;
  breadcrumbs: BreadcrumbItemType[];
}

const ROUTE_MAP: Record<string, RouteMeta> = {
  '/': {
    title: 'Visão Geral',
    breadcrumbs: [{ label: 'Início' }],
  },
  '/market-research': {
    title: 'Planejamento de Pesquisa',
    breadcrumbs: [
      { label: 'Início', to: '/' },
      { label: 'Planejamento de Pesquisa' },
    ],
  },
  '/market-research/map': {
    title: 'Visão em Mapa',
    breadcrumbs: [
      { label: 'Início', to: '/' },
      { label: 'Planejamento', to: '/market-research' },
      { label: 'Mapa' },
    ],
  },
  '/market-research/seller-coverage': {
    title: 'Visão em Mapa',
    breadcrumbs: [
      { label: 'Início', to: '/' },
      { label: 'Planejamento', to: '/market-research' },
      { label: 'Cobertura de Vendas' },
    ],
  },
  '/market-research/reseller-coverage': {
    title: 'Consolidado por Revenda',
    breadcrumbs: [
      { label: 'Início', to: '/' },
      { label: 'Planejamento', to: '/market-research' },
      { label: 'Consolidado por Revenda' },
    ],
  },
  '/market-research/settings': {
    title: 'Configuração de Pesquisa',
    breadcrumbs: [
      { label: 'Início', to: '/' },
      { label: 'Planejamento', to: '/market-research' },
      { label: 'Configuração' },
    ],
  },
  '/market-research/details': {
    title: 'Detalhes da Pesquisa',
    breadcrumbs: [
      { label: 'Início', to: '/' },
      { label: 'Planejamento', to: '/market-research' },
      { label: 'Detalhes' },
    ],
  },
  '/market-research/products-not-searched': {
    title: 'Produtos Não Pesquisados',
    breadcrumbs: [
      { label: 'Início', to: '/' },
      { label: 'Planejamento', to: '/market-research' },
      { label: 'Produtos Não Pesquisados' },
    ],
  },
  '/masterdata/resale': {
    title: 'Gestão de Revenda',
    breadcrumbs: [
      { label: 'Início', to: '/' },
      { label: 'Dados Mestre' },
      { label: 'Revenda' },
    ],
  },
  '/masterdata/product': {
    title: 'Gestão de Produtos',
    breadcrumbs: [
      { label: 'Início', to: '/' },
      { label: 'Dados Mestre' },
      { label: 'Produto' },
    ],
  },
  '/masterdata/pdv': {
    title: 'Gestão de PDVs',
    breadcrumbs: [
      { label: 'Início', to: '/' },
      { label: 'Dados Mestre' },
      { label: 'PDVs' },
    ],
  },
  '/masterdata/non-research-reason': {
    title: 'Motivos de Não Pesquisa',
    breadcrumbs: [
      { label: 'Início', to: '/' },
      { label: 'Dados Mestre' },
      { label: 'Não Pesquisa' },
    ],
  },
  '/access/user': {
    title: 'Gestão de Usuários',
    breadcrumbs: [
      { label: 'Início', to: '/' },
      { label: 'Acesso' },
      { label: 'Usuários' },
    ],
  },
  '/access/user-permissions': {
    title: 'Permissões de Acesso',
    breadcrumbs: [
      { label: 'Início', to: '/' },
      { label: 'Acesso' },
      { label: 'Permissões' },
    ],
  },
};

export function getRouteMeta(pathname: string): RouteMeta {
  if (ROUTE_MAP[pathname]) {
    return ROUTE_MAP[pathname];
  }

  // Fallback dynamic generator for unmatched subroutes
  const parts = pathname.split('/').filter(Boolean);
  if (parts.length === 0) {
    return { title: 'Início', breadcrumbs: [{ label: 'Início' }] };
  }

  const breadcrumbs: BreadcrumbItemType[] = [{ label: 'Início', to: '/' }];
  let currentPath = '';

  parts.forEach((part, idx) => {
    currentPath += `/${part}`;
    const isLast = idx === parts.length - 1;
    const formattedLabel = part
      .replace(/-/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());

    breadcrumbs.push({
      label: formattedLabel,
      to: isLast ? undefined : currentPath,
    });
  });

  return {
    title: breadcrumbs[breadcrumbs.length - 1].label,
    breadcrumbs,
  };
}
